function generateXHR(method, url, data = {}, header={}, message={}){

	const xhr = new XMLHttpRequest();

	// console.log("generateXHR message", Object.keys(message).length, message);
	if(url.substr(0, 4)!="http"){
		url =  process.env.VUE_APP_VITRINE_API + url;
	}

	xhr.open(method, url);

	// if(Object.keys(message).length){
	// 	store.commit("notifPush", message);
	// }

	xhr.upload.addEventListener('progress', function(message, evt){
		var percent = Math.round(evt.loaded/evt.total*100);

		// console.log("xhr.upload.addEventListener progress", evt, message, percent);

		if(message && Object.keys(message).length){
			message.message = 'Upload progress: ' + percent + '%';
			// console.log("message", message);
			// store.commit("notifPush", message);
		}

	}.bind(null, message), false);

	let headerDefault = {
		'Accept':'application/json',
		'Content-Type':'application/json',
	};
	xhr.withCredentials = false;

	if(header!==false){
		header = Object.assign(headerDefault, header);
		for(var i=0;  i< Object.keys(header).length; i++){
			let val = header[ Object.keys(header)[i] ];
			if(val) xhr.setRequestHeader(Object.keys(header)[i], val);
		}
	}

	if(data instanceof FormData){
		xhr.send(data);
	}else{
		xhr.send(JSON.stringify(data));
	}

	const promise = new Promise(function(resolve, reject){
		xhr.onload = () => {
			let json = JSON.parse(xhr.response);
			if(xhr.status >= 200 && xhr.status < 400 && xhr.response){
				return resolve(json);
			}else{
				return reject(json, xhr);
			}
		};
		xhr.onerror = () => {
		};
	});

	promise.xhr = xhr;

	promise.abort = function(){
		return xhr.abort();
	};

	return promise;
}


function recursive(path, value, formdata){
	if(Array.isArray(value)){
		value.forEach((value, key) => {
			recursive(path.concat(key), value, formdata);
		});
	}else if(value instanceof Object){
		Object.keys(value).forEach((key) => {
			recursive(path.concat(key), value[key], formdata);
		});
	}else{
		formdata.append(formatPath(path), value);
	}
}

function formatPath(path){
	const path0 = path[0];
	const pathReste = path.slice(1);
	if(pathReste.length>0){
		return path0 + "["+ pathReste.join('][') + "]";
	}
	return path0;
}

export default generateXHR;
